


import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute} from "@angular/router";
import {AuthService} from "../../login/data-access/auth.service";
import {
  faPenToSquare,
  faCheck,
  faXmark,
  faDownload,
  faPlus,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faTrash,
  faAdd
} from "@fortawesome/free-solid-svg-icons";
import {RoleService} from "../../admin/data-access/role.service";
import {SubjectsModel} from "../../admin/data-access/subjects.model";
import {UnitsModel} from "../../admin/data-access/units.model";
import {RoleDetail} from "../../admin/feature/userManagement/userRolesList/userRolesList.component";
import {Course} from "../../admin/data-access/course.model";
import {MatSnackBar} from "@angular/material/snack-bar";
import { jsPDF } from "jspdf";
import {Subscription} from "rxjs";
import {OrganizationsModel} from "../../admin/data-access/organizations.model";
import { CourseService } from 'src/app/admin/data-access/course.service';
import { SystemManagementService } from 'src/app/admin/data-access/system-management.service';

interface ExtraTime {
  course_name: string
  course_id: string
  title: string
  date: Date
  time_multiplier: number
  time_addition: number
  user_id: number
  expanded?: boolean
}
interface RoleResponse {
  role_name: string
  role_id: string,
  date?: Date
}
export interface RoleTempInterface {
  name: string
  role_id: string
  organization_id?: number
  organization_name?: string
  role_name?: string
  subject_id?: number
  unit_id?: number
  course_id?: number
  date?: Date
  subjects?: SubjectsModel[]
  units?: UnitsModel[]
  organizations?: OrganizationsModel[]
  courses?: Course[]
}
interface UserDetail {
  email: string
  user_id: number
  email_alts: string[]
  roles: RoleResponse[]
  extra_time: ExtraTime[]
  given_name: string
  family_name: string
  student_id: string
  nickname: string
  username: string
  pronouns: string
  display_name: string
  description: string
}
interface AcceptedAgreement {
  agreement_id: number,
  name: string,
  response_date: string,
  agreement_text: string,
  retire_date?: Date
}
@Component({
    selector: 'userProfile',
    templateUrl: './userProfile.html',
    styleUrls: ['userProfile.css'],
    standalone: false
})
export class UserProfileComponent implements OnInit, OnDestroy {
  constructor(
    private systemManagementService: SystemManagementService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private roleService: RoleService,
    private _snackBar: MatSnackBar) {
  }
  faPenToSquare = faPenToSquare
  faChevronRight = faChevronRight
  faCheck = faCheck
  faXmark = faXmark
  faDownload = faDownload
  faPlus = faPlus
  faChevronDown = faChevronDown
  faChevronUp = faChevronUp
  faTrash = faTrash
  expandAgreements = false
  //TODO can use null as a way to determine if loading
  user: UserDetail | null = null
  userAgreements: AcceptedAgreement[] = []
  editFormIsOpened: boolean = false
  saveChangesDialog: boolean = false
  agreementTextIsOpened: boolean = false
  removedEmailAlts: string[] = []
  agreementTextDialogString: string = ''
  agreementTitleDialog: string = ''
  secondaryEmailValidation = false
  showMoreAgreements = false
  openAddAssignTimeDialog = false
  openResetPasswordDialog = false
  adaTitle = ""
  adaTimeMultipler?: number
  adaTimeAddition?: number
  userRoles: RoleTempInterface[] = []
  addedUserRoles: RoleTempInterface[] = []
  addedUserRolesToBeSaved: RoleTempInterface[] = []
  addedTempUserRole: RoleTempInterface[] = []
  openAddRoleDialog: boolean = false;
  assignRoleDetails: RoleDetail | null = null;
  subjectList: SubjectsModel[] = [];
  addedSubjectList: SubjectsModel[] = [];
  unitList: UnitsModel[] = [];
  addedUnitList: UnitsModel[] = [];
  courseList: Course[] = [];
  addedCourseList: Course[] = [];
  orgList: OrganizationsModel[] = [];
  addedOrgList: OrganizationsModel[] = []
  adaTitleValidation = false;
  adaTimeAddValidation = false;
  adaTimeMultValidation = false;
  adaCourseValidation = false;
  extraTime: ExtraTime[] = [];
  openDeleteTimeDialog = false;
  deleteTimeID: string | null = null;
  deleteCourseName = '';
  adaResponseMsg = '';
  showMoreTime = false;
  showMoreRoles = false;
  roleManager = false
  accommodationManager = false
  currentDate = new Date()
  confirmDeleteRole = false
  roleToDelete: RoleTempInterface | null = null
  openProfileImageChange = false
  listOfProfileImages: string[] = this.authService.listOfProfileImages
  selectedProfileImage: number | null = null
  changedProfileImage: number | null = null

  ngOnInit() {
    this.getUserDetails();
  }

  ngOnDestroy() {
    this.userPermissionSub.unsubscribe()
  }

  userPermissionSub: Subscription = this.authService.userDashboard$.subscribe((user) => {
    if(user.result.some(el => el.ui === 'UserRoleManage') || user.result.some(el => el.ui === 'RoleCreate')) {
      this.roleManager = true
    }
    if(user.result.some(el => el.ui === 'AccommodationManage')) {
      this.accommodationManager = true
    }
  })

  getUserDetails() {
    this.route.queryParams.subscribe(params => {
      this.addedUserRoles = [];
      this.authService.getProfileDetails(params['email']).subscribe((response) => {
        this.user = response.result
        this.selectedProfileImage = response.result.profile_pic
        this.changedProfileImage = response.result.profile_pic
        this.addedUserRolesToBeSaved = this.addedUserRoles;
        if(response.result.email_alts != null)
          this.removedEmailAlts = response.result.email_alts
        if(response.result.extra_time != null) {
          this.extraTime = response.result.extra_time
        }
        this.addedUserRoles = response.result.roles
      })
      this.authService.getProfileAgreements(params['email']).subscribe((response) => {
        this.userAgreements = response.result
        this.userAgreements.forEach((agreement: AcceptedAgreement) => {
          agreement.response_date = new Date(agreement.response_date).toLocaleDateString()
        })
      })
      this.roleService.listAllUserRoles().subscribe((response) => {
        if(response.success)
          for(let role of response.items)
            this.userRoles.push({name:role.name, role_name: role.role_name, organization_name: '', role_id: role.role_id})
      })
    })
  }

  openEditProfile() {
    this.editFormIsOpened = true;
    this.secondaryEmailValidation = false;
  }

  closeEditProfile() {
    this.editFormIsOpened = false;
    this.changedProfileImage = this.selectedProfileImage
  }

  removeRole(addedRole: RoleTempInterface) {
    this.addedUserRolesToBeSaved = this.removeItemFromList(addedRole, this.addedUserRolesToBeSaved)
    console.log(this.addedUserRolesToBeSaved)
    console.log(this.addedUserRoles)
  }

  saveEditProfile() {
    // TODO need to compare to be added roles and added roles
    const name: HTMLInputElement = document.getElementById('name') as HTMLInputElement;
    const pronouns: HTMLInputElement = document.getElementById('pronouns') as HTMLInputElement;
    const secondaryEmail: HTMLInputElement = document.getElementById('secondaryEmail') as HTMLInputElement;
    const department: HTMLInputElement = document.getElementById('department') as HTMLInputElement;

    const regEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if(secondaryEmail.value !== '' && !regEmail.test(secondaryEmail.value)) {
      this.secondaryEmailValidation = true
    } else {
      let email = '';
      this.route.queryParams.subscribe(params => {
        if(params['email'] === 'mine')
          email = 'mine';
        else
          email = this.user? this.user.email : '';
      })

      if(this.user !== null) {
        // TODO add role is fine remove role is bugged, fix it without having to call the API so it doesn't remove important roles
        if(this.addedUserRolesToBeSaved.length > this.addedUserRoles.length) {
          for(let i = 0; i < this.addedUserRolesToBeSaved.length; i++) {
            if(i < this.addedUserRoles.length) {
              if(JSON.stringify(this.addedUserRolesToBeSaved[i]) !== JSON.stringify(this.addedUserRoles[i])) {
                // TODO need to entirely rework this portion of assigning and removing roles
                this.roleService.assignOrRemoveRole(this.user.email, this.addedUserRoles[i].role_id, this.addedUserRoles[i].subjects, this.addedUserRoles[i].units, [], [], true).subscribe()
                this.roleService.assignOrRemoveRole(this.user.email, this.addedUserRolesToBeSaved[i].role_id, this.addedUserRolesToBeSaved[i].subjects, this.addedUserRolesToBeSaved[i].units, [], [],false).subscribe()
              }
            } else {
              this.roleService.assignOrRemoveRole(this.user.email, this.addedUserRolesToBeSaved[i].role_id, this.addedUserRolesToBeSaved[i].subjects, this.addedUserRolesToBeSaved[i].units, [], [],false).subscribe()
            }
          }
        }
        else {
          for(let i = 0; i < this.addedUserRoles.length; i++) {
            if(i<this.addedUserRolesToBeSaved.length) {
              if(JSON.stringify(this.addedUserRolesToBeSaved[i]) !== JSON.stringify(this.addedUserRoles[i])) {
                this.roleService.assignOrRemoveRole(this.user.email, this.addedUserRoles[i].role_id, this.addedUserRoles[i].subjects, this.addedUserRoles[i].units, [], [],true).subscribe()
                this.roleService.assignOrRemoveRole(this.user.email, this.addedUserRolesToBeSaved[i].role_id, this.addedUserRolesToBeSaved[i].subjects, this.addedUserRolesToBeSaved[i].units, [], [],false).subscribe()
              }
            } else {
              this.roleService.assignOrRemoveRole(this.user.email, this.addedUserRoles[i].role_id, this.addedUserRoles[i].subjects, this.addedUserRoles[i].units, [], [],true).subscribe()
            }
          }
        }

        this.authService.saveProfileEdit(email, name.value, pronouns.value, department.value, '', [secondaryEmail.value], this.removedEmailAlts, this.changedProfileImage).subscribe((response) => {
          if (response.success && response.msg === 'changes recorded') {
            this.saveChangesDialog = true;
            this.editFormIsOpened = false;
            setTimeout(() => {
              this.saveChangesDialog = false;
              this.getUserDetails()
              if(this.changedProfileImage !== this.selectedProfileImage) {
                window.location.reload()
              }
            }, 4000)
            this.userRoles = []
          } else {
            this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
          }
        })
      }
    }
  }

  openAgreementText(iter: number) {
    this.agreementTextIsOpened = true;
    this.agreementTextDialogString = this.userAgreements[iter].agreement_text;
    this.agreementTitleDialog = this.userAgreements[iter].name;
  }

  checkForHTMLTags(test?: string): boolean {
    if(test != null)
      return /<\/?[a-z][\s\S]*>/i.test(test)
    else
      return false
  }

  closeAgreementTextDialog() {
    this.agreementTextIsOpened = false;
  }

  downloadTextAgreement() {
    const doc = new jsPDF("p", "pt", 'a4')
    const getContent = "<div style='font-size:11px; border:1px solid; background-color: rgb(239 240 240); padding: 05px 15px; width:300px;'>"+this.agreementTextDialogString+"</div>";
    if(this.checkForHTMLTags(this.agreementTextDialogString)) {
      doc.html(getContent, {
        callback: function (doc) {
          doc.save()
        },
        filename: this.agreementTitleDialog + '.pdf',
        autoPaging: 'text',
        x: 15,
        y: 10
      })
    } else {
      const splitText = doc.splitTextToSize(this.agreementTextDialogString, 180)
      let i = 0;
      let pageNum = 1;
      for(let iter = 0; iter < splitText.length; iter++) {
        doc.setPage(pageNum)
        doc.text(splitText[iter], 15, 10 * (i + 1))
        i += 1
        if(i === 28) {
          doc.addPage()
          pageNum += 1
          i = 0
        }
      }
      doc.save(this.agreementTitleDialog + '.pdf')
    }
  }

  saveTimeClick() {
    this.adaTitleValidation = this.adaTitle === "";
    this.adaTimeAddValidation = this.adaTimeAddition == null || this.adaTimeAddition.toString() === "";
    this.adaTimeMultValidation = this.adaTimeMultipler == null || this.adaTimeMultipler.toString() === "";
    this.adaCourseValidation = this.addedOrgList.length === 0;
    if(!this.adaTitleValidation && !(this.adaTimeAddValidation && this.adaTimeMultValidation) && !this.adaCourseValidation && this.user != null) {
      this.roleService.addAdaTime(this.user.user_id, this.adaTitle, this.addedOrgList[0].organization_id, this.adaTimeMultipler, this.adaTimeAddition).subscribe((response) => {
        if(response.success) {
          this.getUserDetails();
          this.openAddAssignTimeDialog = false;
          this._snackBar.open('ADA time successfully added', 'Dismiss', {duration: 3000})
          this.adaTitle = "";
          this.adaTimeMultipler = 0;
          this.adaTimeAddition = 0;
        } else if(response.msg === "user already has accommodation for this course") {
          this.adaResponseMsg = response.msg
        }
      })
    }
  }

  cancelAssignDialog() {
    this.openAddAssignTimeDialog = false;
    this.adaTitleValidation = false;
    this.adaTimeAddValidation = false;
    this.adaTimeMultValidation = false;
    this.adaCourseValidation = false;
    this.adaTitle = ""
    this.adaTimeAddition = undefined
    this.adaTimeMultipler = undefined
    this.addedOrgList = [];
  }

  removeItemFromList(item: any, list: any[]) {
    return list.filter(e => JSON.stringify(e) !== JSON.stringify(item));
  }

  openRoleClick(role_id: string, subjects?: SubjectsModel[], units?: UnitsModel[]) {
    // TODO get the role details also from the init response
    this.roleService.getRoleDetail(role_id.toString()).subscribe((response) => {
      if(response.success) {
        this.assignRoleDetails = {
          name: response.result.name,
          role_id: response.result.role_id,
          organizations: response.result.organizations,
          subjects: response.result.subjects,
          units: response.result.units
        }
        this.subjectList = response.result.subjects;
        this.unitList = response.result.units;
      }
    })
    if(subjects != null)
      this.addedSubjectList = subjects;
    if(units != null)
      this.addedUnitList = units;
    this.openAddRoleDialog = true;
  }

  saveNewRole(role: RoleTempInterface[]) {
    // TODO call the api to add the role
    if(role.length > 0) {
      this.addedUserRolesToBeSaved = this.addedUserRolesToBeSaved.filter(e => JSON.stringify(e) !== JSON.stringify({name: role[0].role_name, role_id: role[0].role_id, subjects: this.addedSubjectList, units: this.addedUnitList}));
      this.addedUserRolesToBeSaved.push({name: '', role_name: role[0].role_name, organization_name: role[0].organization_name, role_id: role[0].role_id, subjects: this.addedSubjectList, units: this.addedUnitList})
    }
    this.addedTempUserRole = []
    this.addedSubjectList = []
    this.addedUnitList = []
    this.openAddRoleDialog = false;
  }

  openAddTime() {
    this.openAddAssignTimeDialog = true;
    this.adaResponseMsg = '';
    this.systemManagementService.listOrgs().subscribe((response) => {
      if (response.success)
        this.orgList = response.result.items
    })
  }

  openDeleteTimeClick(course_id: string, course_name: string) {
    this.deleteTimeID = course_id;
    this.deleteCourseName = course_name;
    this.openDeleteTimeDialog = true;
  }

  closeDeleteTimeClick() {
    this.deleteCourseName = '';
    this.openDeleteTimeDialog = false;
    this.deleteTimeID = null;
  }

  confirmDeleteTimeClick() {
    if(this.deleteTimeID != null && this.user != null) {
      this.roleService.deleteAdaTime(this.user.email, this.deleteTimeID).subscribe((response) => {
        if(response) {
          this._snackBar.open('ADA time successfully removed', 'Dismiss', {duration: 3000})
          this.getUserDetails()
        }
        this.closeDeleteTimeClick()
      })
    }
  }

  openConfirmDeleteRole(role: RoleTempInterface) {
    this.roleToDelete = role
    this.confirmDeleteRole = true
  }

  cancelDeleteRole() {
    this.roleToDelete = null
    this.confirmDeleteRole = false
  }

  confirmRemoveRole(role: RoleTempInterface | null) {
    if(this.user != undefined && role != null)
      this.roleService.removeRole(this.user.email, role).subscribe((response) => {
        if(response.success) {
          this.getUserDetails()
          this._snackBar.open('Role successfully removed', 'Dismiss', {duration: 3000})
          this.cancelDeleteRole()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    else
      this._snackBar.open('Role or user undefined', 'Dismiss', {panelClass: ['error-snackbar']})
  }

  // TODO test adding a role
  addRole(role_id: string, org_id: string, subject_id: string, unit_id: string, course_id: number) {
    const role: RoleTempInterface = {
      name: '',
      role_id: role_id,
      organization_id: Number(org_id),
      subject_id: Number(subject_id),
      unit_id: Number(unit_id),
      course_id: course_id
    }
    if(this.user != undefined && role != null) {
      this.roleService.addRole(this.user.email, role).subscribe((response) => {
        if(response.success) {
          this.getUserDetails()
          this._snackBar.open('Role successfully added', 'Dismiss', {duration: 3000})
          this.openAddRoleDialog = false
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
  }

  selectProfileImage(index: number) {
    this.changedProfileImage = index
    this.openProfileImageChange = false
  }

  protected readonly JSON = JSON;
  protected readonly Date = Date;
  protected readonly faAdd = faAdd;
}
